import * as React from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  List,
  ListItem,
  ListItemIcon,
  Typography,
  useTheme,
} from "@mui/material";
import Home from "../icons/Home";
import Companies from "../icons/Companies";
import Pen from "../icons/Pen";
import Policies from "../icons/Policies";
import News from "../icons/News";
import Claims from "../icons/claims";
import QuestionCircle from "../icons/QuestionCircle";
import { isCustomer } from "../../../utils/constants";
import useLocalization from "../../../hooks/useLocalization";
import ManageUsers from "../icons/ManageUsers";

export default function DemoListItems({ handleOpenResources, open }) {
  const location = useLocation();
  const [selectedIndex, setSelectedIndex] = React.useState(null);
  const theme = useTheme();

  const { t } = useLocalization("sidebar");

  const itemMenus = React.useMemo(
    () =>
      [
        {
          selected:
            selectedIndex !== 6 && location.pathname.includes("my-dashboard"),
          label: t("my_dashboard"),
          color: "primary",
          icon: <Home />,
          url: "/my-dashboard",
        },
        !isCustomer && {
          selected: selectedIndex !== 6 && location.pathname.includes("client"),
          label: t("clients"),
          color: "primary",
          icon: <Companies />,
          url: "/my-clients",
        },
        {
          selected:
            selectedIndex !== 6 && location.pathname.includes("application"),
          label: t("my_applications"),
          color: "primary",
          icon: <Pen />,
          url: "/my-applications",
        },
        {
          label: t("my_policies"),
          selected:
            selectedIndex !== 6 &&
            (location.pathname.includes("policies") ||
              location.pathname.includes("policy")),
          color: "primary",
          icon: <Policies />,
          url: "/my-policies",
        },
        {
          selected: selectedIndex !== 6 && location.pathname.includes("claim"),
          label: t("my_claims"),
          color: "primary",
          icon: <Claims />,
          url: "/my-claims",
        },
        {
          selected: selectedIndex !== 6 && location.pathname.includes("news"),
          label: t("news"),
          color: "primary",
          icon: <News />,
          url: "/news",
        },
        {
          selected:
            selectedIndex !== 6 && location.pathname.includes("manage-users")
              ? true
              : false,
          label: "Manage Users",
          color: "primary",
          icon: <ManageUsers />,
          url: "/manage-users",
        },
        {
          selected: selectedIndex === 6,
          label: t("resources"),
          color: "primary",
          icon: <QuestionCircle />,
          url: "#",
        },
      ].filter(Boolean),
    [t, location.pathname, selectedIndex]
  );

  const history = useHistory();

  const handleMenuItemClick = (itemMenu) => {
    setSelectedIndex(itemMenu.index);

    if (itemMenu.label === t("resources")) {
      handleOpenResources();
    } else {
      //setAnchorEl(null);

      history.push(itemMenu.url);
    }
  };

  const handleClose = () => {
    //setAnchorEl(null);
  };
  // <List anchorEl={anchorEl} keepMounted open={true} onClose={handleClose} elevation="0" sx={{ mt: 6 }}>

  return (
    <List
      open={true}
      onClose={handleClose}
      elevation="0"
      sx={{
        mt: 2,
      }}
    >
      {itemMenus?.map((itemMenu, index) => {
        return (
          itemMenu?.label && (
            <ListItem
              id={`list-item-${index}`}
              key={index}
              selected={itemMenu.selected}
              onClick={() => handleMenuItemClick(itemMenu)}
              sx={{
                pr: 0,
                mt: 1,
                gap: "14px",
                borderRadius: "8px",
                "&:hover": {
                  backgroundColor: theme?.palette?.primary?.sideBarActiveColor,
                },
                "&.Mui-selected": {
                  backgroundColor: theme?.palette?.primary?.sideBarActiveColor,
                },
                "&.Mui-selected:hover": {
                  backgroundColor: theme?.palette?.primary?.sideBarActiveColor,
                },
              }}
            >
              <ListItemIcon
                sx={{
                  color: itemMenu.selected
                    ? theme.palette?.primary?.dark
                    : theme.palette?.primary?.textColor,
                  fill: itemMenu.selected
                    ? theme.palette?.primary?.dark
                    : theme.palette?.primary?.textColor,
                  fontWeight: itemMenu.selected && "bold",
                  minWidth: "0px !important",
                }}
              >
                {itemMenu.icon}
              </ListItemIcon>
              <Typography
                sx={{
                  fontSize: "0.85rem",
                  textWrap: "wrap",
                  color: itemMenu.selected
                    ? theme.palette?.primary?.dark
                    : theme.palette?.primary?.textColor,
                  whiteSpace: "normal",
                  fontWeight: itemMenu.selected && "bold",
                }}
                primaryTypographyProps={{
                  style: {},
                }}
              >
                {open ? itemMenu.label : <span>&nbsp;</span>}
              </Typography>
            </ListItem>
          )
        );
      })}
    </List>
  );

  // return (
  // 	<List>
  // 		{itemMenus.map((itemMenu, index) => {
  // 			return (
  // 				<ListItem
  // 					selected={index === selectedIndex}
  // 					disableRipple
  // 					key={index}
  // 					button
  // 					sx={{ paddingBottom: listSpacing }}
  // 					component={NavLink}
  // 					to={itemMenu.url}
  // 					keepMounted
  // 				>
  // 					<ListItemIcon>{itemMenu.icon}</ListItemIcon>
  // 					<ListItemText
  // 						sx={{ fontSize: listSize }}
  // 						disableTypography
  // 						primary={itemMenu.label}
  // 						color={itemMenu.color}
  // 						onClick={() => handleClick(itemMenu.url)}
  // 					/>
  // 				</ListItem>
  // 			);
  // 		})}
  // 	</List>
  // );
}

// export const secondaryListItems = (
//   <div>
//     <ListSubheader inset>Saved reports</ListSubheader>
//     <ListItem button>
//       <ListItemIcon>
//         <AssignmentIcon />
//       </ListItemIcon>
//       <ListItemText primary="Current month" />
//     </ListItem>
//     <ListItem button>
//       <ListItemIcon>
//         <AssignmentIcon />
//       </ListItemIcon>
//       <ListItemText primary="Last quarter" />
//     </ListItem>
//     <ListItem button>
//       <ListItemIcon>
//         <AssignmentIcon />
//       </ListItemIcon>
//       <ListItemText primary="Year-end sale" />
//     </ListItem>
//   </div>
// );
